import FormattedMessage from 'I18n/components/FormattedMessage';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyFormattedTooltip = ({
  children,
  normalizationRules
}) => {
  const hasAlphanumericRule = normalizationRules.includes('ALPHANUMERIC');
  const hasSpecialCharactersRule = normalizationRules.includes('SPECIAL_CHARACTERS');
  const hasUpperRule = normalizationRules.includes('UPPER');
  const hasLowerRule = normalizationRules.includes('LOWER');
  const hasCapitalizationRule = normalizationRules.includes('CAPITALIZATION');
  const hasWhitespaceRule = normalizationRules.includes('WHITESPACE');
  const hasTrimWhitespaceRule = normalizationRules.includes('TRIM_WHITESPACE');
  const hasHandledNormalizationRules = useMemo(() => {
    if (normalizationRules.length === 0) {
      return false;
    }
    return hasAlphanumericRule || hasSpecialCharactersRule || hasUpperRule || hasLowerRule || hasCapitalizationRule || hasWhitespaceRule || hasTrimWhitespaceRule;
  }, [normalizationRules, hasAlphanumericRule, hasSpecialCharactersRule, hasUpperRule, hasLowerRule, hasCapitalizationRule, hasWhitespaceRule, hasTrimWhitespaceRule]);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !hasHandledNormalizationRules,
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.NormalizationMessage.heading"
    }),
    title: /*#__PURE__*/_jsxs(List, {
      styled: true,
      children: [hasAlphanumericRule && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.NormalizationMessage.numbersOnly"
        })
      }), hasSpecialCharactersRule && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.NormalizationMessage.dontAllowSpecialCharacters"
        })
      }), hasWhitespaceRule && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.NormalizationMessage.noWhitespace"
        })
      }), hasTrimWhitespaceRule && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.NormalizationMessage.trimWhitespace"
        })
      }), hasUpperRule && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.NormalizationMessage.onlyAllowUppercase"
        })
      }), hasLowerRule && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.NormalizationMessage.onlyAllowLowercase"
        })
      }), hasCapitalizationRule && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.NormalizationMessage.onlyAllowCapitalization"
        })
      })]
    }),
    open: Boolean(hasHandledNormalizationRules),
    use: "longform",
    children: children
  });
};
export default PropertyFormattedTooltip;